/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { DirectionData, PrefijoPais } from '../../../types/PersonalData';
import useAPIError from '../../../hooks/useAPIError';
import { MisDatosService } from '../../../services';
import { useAuthStore } from '../../../store/AuthContext';
import { GoogleLocation, ItemGoogle } from '../../../types/Types';
import { DirectionsHelper } from '../DirectionsHelper';
import { MisDatosHelper } from '../MisDatosHelper';
import { GooglePlaceHelper } from '../../../utils/GooglePlaceHelper';
import { MisDatosConstants } from '../../../utils/MisDatosConstants';
import { StorageHelper } from '../../../utils/StorageHelper';
import { TextHelper } from '../../../utils/TextHelper';
import IconBack from '../../../Icons/IconBack';
import IconChat from '../../../Icons/IconChat';
import { HostProvider } from '../../../utils/HostProvider';

interface Props {
  title?: string;
  directionData: DirectionData;
  isAdd: boolean;
  cargarDirecciones: () => void;
  prefijosPaises: PrefijoPais[];
  onLoad: boolean;
  setOnLoad: (onLoad: boolean) => void;
}

const DirectionForm: FC<Props> = (props) => {
  let selectedIndex = -1;
  const dataUser = useAuthStore();
  const {
    directionData,
    isAdd,
    cargarDirecciones,
    prefijosPaises,
    onLoad,
    setOnLoad,
  } = props;
  const isEroski = HostProvider.isEroski();
  const isCaprabo = HostProvider.isCaprabo();
  const { addError, addErrorBack } = useAPIError();
  const [prefijo, setPrefijo] = useState('');
  const [tamTelf, setTamTelf] = useState(9 as number);
  const { t } = useTranslation();
  const [postalCode, setPostalCode] = useState('' as string);
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    reset,
    setValue,
    clearErrors,
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      localidadEntrega: directionData.locality,
      prefijoTelefonoMovil: directionData.idPrefTelefono1,
      tfOnline: directionData.telefono1,
      codPostal: directionData.postalCode,
      viaEntrega: directionData.roadName,
      numEntrega: directionData.number,
    },
  });
  const [dirSave, setDirSave] = useState<boolean>(false);
  const [clickSetValue, setClickSetValue] = useState<boolean>(false);
  const [firstRoadValue, setFirstRoadValue] = useState<any>(null);
  const [clickRoadValue, setClickRoadValue] = useState<boolean>(false);
  const [showAutoC, setShowAutoC] = useState<boolean>(false);
  const [showAutoC2, setShowAutoC2] = useState<boolean>(false);
  const [unlockLocality, setUnlockLocality] = useState<boolean>(false);
  const [lockLocality, setLockLocality] = useState<boolean>(false);
  const [clearLocalityError, setClearLocalityError] = useState<boolean>(false);
  const [findIn, setFindIn] = useState<string>('');
  const [postalGeoData] = useState<ItemGoogle>({
    input: '',
    types: '',
    components: '',
    latitud: '',
    longitud: '',
    sessiontoken: '',
    idDireccion: '',
    proceso: '',
    tipoC: '',
    tipoR: '',
  });
  const [location, setLocation] = useState<GoogleLocation[]>([]);
  const [locationRoad, setLocationRoad] = useState<GoogleLocation[]>([]);
  const [selectLocation, setSelectLocation] = useState<GoogleLocation>({
    value: '',
    tamanio: -1,
    id: -1,
    codigo: '',
  });
  const [isPostalCode, setIsPostalCode] = useState<boolean>(false);
  const [error, setErrorCpNoSeleccionado] = useState<boolean>(false);
  const [tempDirectionData, setTempDirectionData] = useState<DirectionData>(
    directionData,
  );
  const [visible, setVisible] = useState<boolean>(false);
  const directionsHelper = new DirectionsHelper();
  const misDatosHelper = new MisDatosHelper();
  const [isFullPrefijo, setIsFullPrefijo] = useState<boolean>(false);
  const [existListener, setExistListener] = useState<boolean>(false);

  const [isValidPref1, setIsValidPref1] = useState(false);

  let tipo = '';
  if (directionData.tipoDireccion === 0) {
    tipo = 'habitual';
  }
  if (directionData.tipoDireccion === 1) {
    tipo = 'entrega';
  }

  const testNumeroByCP = (cp: string) => {
    const regAndorraGibraltar = {
      required: false,
    };
    const regSpain = {
      required: true,
      pattern: /^[0-9]+$/i,
    };
    return directionsHelper.checkIfCPIsGibraltar(cp) ||
      directionsHelper.checkIfCPIsAndorra(cp)
      ? regAndorraGibraltar
      : regSpain;
  };

  const inicalizarPrefijosYTelefonos = () => {
    if (isAdd) {
      if (prefijosPaises && prefijosPaises[0]) {
        setPrefijo(prefijosPaises[0].prefijo);
        setIsFullPrefijo(true);
        setTempDirectionData({
          ...directionData,
          idPrefTelefono1: prefijosPaises[0].id.toString(),
        });
        setTamTelf(prefijosPaises[0].tamanioTelefono);
        setIsValidPref1(true);
      }
    } else {
      setPostalCode(directionData.postalCode);
      if (prefijosPaises && prefijosPaises[0]) {
        prefijosPaises.forEach((currentValue) => {
          if (currentValue.id.toString() === directionData.idPrefTelefono1) {
            setPrefijo(currentValue.prefijo);
            setTempDirectionData({
              ...directionData,
              idPrefTelefono1: currentValue.id.toString(),
            });
            setTamTelf(currentValue.tamanioTelefono);
            setIsFullPrefijo(true);
            setIsValidPref1(true);
          }
        });
      }
    }
  };

  const updateDireccion = () => {
    setDirSave(true);
  };

  const addDireccion = () => {
    tempDirectionData.tipoDireccion = MisDatosConstants.ID_TIPO_ENTREGA;
    setDirSave(true);
  };

  const showErrors = () => {
    let nombreComponenteError = 'cod-entrega-';
    let nombreLabelNoSelectError = 'codPostal-error-not-selected-';
    const nombreLabelError = 'codPostal-error';
    if (tempDirectionData.idDireccion !== null) {
      nombreComponenteError = `cod-entrega-${tempDirectionData.idDireccion}`;
      nombreLabelNoSelectError = `codPostal-error-not-selected-${tempDirectionData.idDireccion}`;
    }
    const labelErrorGeneral = document.getElementById(
      nombreLabelError,
    ) as HTMLLabelElement;
    const labelError = document.getElementById(
      nombreLabelNoSelectError,
    ) as HTMLLabelElement;
    const componenteError = document.getElementById(
      nombreComponenteError,
    ) as HTMLInputElement;
    if (labelError !== null) {
      labelError.classList.add('hide');
    }
    if (labelErrorGeneral !== null) {
      labelErrorGeneral.classList.add('hide');
    }
    const valorCp = componenteError.value;
    const regexGibraltar = /(^[0-9]{5}$)|^(GX11 1AA)$/i;
    const isGibraltarOk = regexGibraltar.test(valorCp);
    if (isGibraltarOk && labelError !== null) {
      labelError.classList.remove('hide');
      componenteError.classList.add('error');
    } else if (labelErrorGeneral !== null) {
      labelErrorGeneral.classList.remove('hide');
    }
  };

  const HandleChange = (key: string, value) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'postalCode':
        setIsPostalCode(true);
        setFindIn('cp');
        if (
          postalCode !== null &&
          postalCode.length >= 3 &&
          prefijo === MisDatosConstants.PREFIJO_GIBRALTAR
        ) {
          setPostalCode(`${value} `);
        } else {
          setPostalCode(value);
        }
        if (value.length === 0) {
          setTempDirectionData({
            ...tempDirectionData,
            postalCode: '',
          });
        }
        if (
          selectLocation &&
          (selectLocation.id === -1 || selectLocation.id === null)
        ) {
          if (!error) {
            setErrorCpNoSeleccionado(true);
          } else {
            showErrors();
          }
        }
        break;
      case 'roadName':
        setIsPostalCode(false);
        setFindIn('via');

        setTempDirectionData({
          ...tempDirectionData,
          roadName: value,
        });
        break;
      case 'locality': {
        let manualLocality = '' as string;
        if (value !== '' && value !== null) {
          manualLocality = MisDatosConstants.LOCALIDAD_DESDE_MIS_DATOS;
        }
        setTempDirectionData({
          ...tempDirectionData,
          locality: value,
          localityType: manualLocality,
        });
        break;
      }
      case 'door':
        setTempDirectionData({
          ...tempDirectionData,
          door: value,
        });
        break;
      case 'floor':
        setTempDirectionData({
          ...tempDirectionData,
          floor: value,
        });
        break;
      case 'stairs':
        setTempDirectionData({
          ...tempDirectionData,
          stairs: value,
        });
        break;
      case 'number':
        setTempDirectionData({
          ...tempDirectionData,
          number: value,
        });
        break;
      case 'portal':
        setTempDirectionData({
          ...tempDirectionData,
          portal: value,
        });
        break;
    }
  };

  const ignorarCaracteresLocalidadNoAceptados = (
    e: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (TextHelper.testLocalidad(e.key) === false) {
      e.preventDefault();
    }
  };

  const onHandleTelephoneChange = (e) => {
    const expRegNum = new RegExp(/^[0-9\b]+$/);
    const telf = e.target.value;

    // if value is not blank, then test the regex
    if (telf === '' || expRegNum.test(telf)) {
      setTempDirectionData({
        ...tempDirectionData,
        telefono1: telf,
      });
    }
  };

  const callGeolocalizacion = () => {
    let country = directionsHelper.setInitialCountryByPostalCode(isEroski);
    if (tipo === 'habitual') {
      country = directionsHelper.setCountryByPostalCode(postalCode);
    }
    if (postalCode.length >= 3) {
      directionsHelper.getGeoLocation(
        true,
        country,
        postalGeoData,
        isPostalCode,
        postalCode,
        tempDirectionData,
        setShowAutoC,
        setShowAutoC2,
        setLocation,
        setLocationRoad,
        setFirstRoadValue,
      );
    } else {
      setShowAutoC(false);
      // setShowAutoC2(false);
    }
  };

  const handleOutsideGeolocalizator = async (e) => {
    const locationList = GooglePlaceHelper.getLocationListElement(
      showAutoC,
      tempDirectionData,
    );

    if (GooglePlaceHelper.getOutPressed(e)) {
      e.preventDefault();
      setShowAutoC(false);
      setShowAutoC2(false);
      document.removeEventListener('mouseup', handleOutsideGeolocalizator);
      document.removeEventListener('keyup', handleOutsideGeolocalizator);
      selectedIndex = GooglePlaceHelper.resetOptions(
        locationList,
        selectedIndex,
      );

      // @ts-ignore
    } else if (GooglePlaceHelper.arrowPressed(e) && !window.ev) {
      const locationChildrenList = locationList.children;
      const listSize = locationChildrenList.length as number;
      if (selectedIndex < -1) {
        selectedIndex = -1;
      } else if (selectedIndex >= listSize) {
        selectedIndex = listSize - 1;
      }
      // @ts-ignore
      if (window.si && window.si === -1) {
        // @ts-ignore
        window.si = 0;
        // @ts-ignore
        selectedIndex = -1;
      }

      GooglePlaceHelper.addMouseOverForResetStyles(
        locationChildrenList,
        listSize,
      );

      selectedIndex = GooglePlaceHelper.moveWithArrowsThrowOptions(
        locationChildrenList,
        selectedIndex,
        e,
      );
    } else if (GooglePlaceHelper.optionSelected(e)) {
      const currentTarget = e.currentTarget.name;
      const activeElement = document.activeElement as HTMLInputElement;
      console.log(currentTarget);
      if (e.currentTarget.name && e.currentTarget.name.includes('viaEntrega')) {
        GooglePlaceHelper.setLocationValue(
          setSelectLocation,
          location,
          selectedIndex,
          locationRoad,
        );
      } else if (activeElement && activeElement.name.includes('codPostal')) {
        const country = directionsHelper.setCountryByPostalCode(
          tempDirectionData.postalCode,
        );
        const localPostalGeoData = directionsHelper.completeInputData(
          country,
          postalGeoData,
          isPostalCode,
          postalCode,
          directionData,
          true,
        );
        await MisDatosService.googlePlaceAutoComplete(localPostalGeoData).then(
          (response) => {
            if (directionsHelper.checkGooglePlaceDetailResponse(response)) {
              setLocation(response.data.pojos);
              setShowAutoC(true);
              setShowAutoC2(false);
            }
          },
        );
      }
      selectedIndex = -1;
    } else if (!GooglePlaceHelper.leftAndRightArrowPressed(e)) {
      e.preventDefault();
      document.removeEventListener('mouseup', handleOutsideGeolocalizator);
      document.removeEventListener('keyup', handleOutsideGeolocalizator);
      selectedIndex = GooglePlaceHelper.resetOptions(
        locationList,
        selectedIndex,
      );
    }
  };

  useEffect(() => {
    if (!isFullPrefijo && directionData.idPrefTelefono1 !== null) {
      inicalizarPrefijosYTelefonos();
    }
  });

  useEffect(() => {
    if (visible && !isFullPrefijo) {
      inicalizarPrefijosYTelefonos();
    }
  }, [visible]);

  useEffect(() => {
    if (dataUser.user.token !== '') {
      inicalizarPrefijosYTelefonos();
      if (
        StorageHelper.isOpenDireccionHabitual() &&
        directionData.tipoDireccion === MisDatosConstants.ID_TIPO_HABITUAL
      ) {
        StorageHelper.removeOpenDireccionHabitual();
        const formDireccion = document.querySelector(
          '[id^="habitual-"]',
        ) as HTMLFormElement;
        if (formDireccion) {
          formDireccion.classList.add('visible');
          const button = document.getElementById(
            `direccion-submit-btn-${directionData.idDireccion}`,
          ) as HTMLElement;
          if (button) button.click();
        }
      }
    }
  }, [dataUser.user.token]);

  //* *** Save with Enter key
  const clase = !isAdd ? `form-${tipo}` : 'form-anadir';

  const saveInfo = (e) => {
    // @ts-ignore
    const showVia = document
      .getElementById(`ui-id-29-${tempDirectionData.idDireccion}`)
      .classList.contains('visible');
    // @ts-ignore
    const showPostalCode = document
      .getElementById(`ui-id-30-${tempDirectionData.idDireccion}`)
      .classList.contains('visible');
    if (
      e.key === 'Enter' &&
      e.keyCode === 13 &&
      !errors.codPostal &&
      !errors.localidadEntrega &&
      !errors.viaEntrega &&
      !errors.numEntrega &&
      !errors.tfOnline &&
      !errors.prefijoTelefonoMovil &&
      !showPostalCode &&
      !showVia
    ) {
      const element = document.querySelector(
        `section.o-section--large.${clase}.visible`,
      ) as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      element.removeEventListener('keydown', saveInfo, false);
      setExistListener(false);
      e.preventDefault();
      e.stopImmediatePropagation();
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document
        .getElementById(`direccion-submit-btn-${directionData.idDireccion}`)
        .click();
    }
  };

  useEffect(() => {
    if (location.length > 0) {
      const focusedElement = document.querySelector('li.li-focused'); // Selecciona el <li> con la clase 'li-focused'
      if (focusedElement) {
        const value = focusedElement.textContent; // Obtiene el texto del <li>
        console.log(value); // Muestra el valor en la consola
        const foundLocation = location.find((loc) => loc.value === value);
        if (foundLocation) {
          setSelectLocation(foundLocation);
        }
      }
    }
  }, [location]); // Se ejecuta cuando `location` cambia

  useEffect(() => {
    if (visible) {
      const element = document.querySelector(
        `section.o-section--large.${clase}.visible`,
      ) as HTMLElement;
      // @ts-ignore
      const showVia = document
        .getElementById(`ui-id-29-${tempDirectionData.idDireccion}`)
        .classList.contains('visible');
      // @ts-ignore
      const showPostalCode = document
        .getElementById(`ui-id-30-${tempDirectionData.idDireccion}`)
        .classList.contains('visible');
      if (
        !errors.codPostal &&
        !errors.localidadEntrega &&
        !errors.viaEntrega &&
        !errors.numEntrega &&
        !errors.tfOnline &&
        !errors.prefijoTelefonoMovil &&
        !showPostalCode &&
        !showVia
      ) {
        if (!existListener) {
          element.setAttribute('tabindex', '0');
          element.focus();
          element.addEventListener('keydown', saveInfo, false);
          setExistListener(true);
        }
      }
    }
  }, [
    errors.codPostal,
    errors.localidadEntrega,
    errors.viaEntrega,
    errors.numEntrega,
    errors.tfOnline,
    errors.prefijoTelefonoMovil,
  ]);

  useEffect(() => {
    if (visible && !existListener) {
      setExistListener(true);
      const element = document.querySelector(
        `section.o-section--large.${clase}.visible`,
      ) as HTMLElement;
      element.setAttribute('tabindex', '0');
      element.focus();
      element.addEventListener('keydown', saveInfo, false);
    }
  }, [visible]);

  const hideForm = () => {
    const element = document.querySelector(
      `section.o-section--large.${clase}.visible`,
    ) as HTMLElement;
    element.setAttribute('tabindex', '0');
    element.focus();
    element.removeEventListener('keydown', saveInfo, false);
    setShowAutoC(false);
    setShowAutoC2(false);
    setClickSetValue(true);
    setVisible(false);
    setExistListener(false);
    setPostalCode('');
    setTempDirectionData(directionData);
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    document
      .querySelector('section.bloque-form.visible')
      .classList.remove('visible');
    document.body.classList.remove('fix');
    const formulario = document.getElementById(
      `form-direccion-${tipo}-${directionData.idDireccion}`,
    ) as HTMLFormElement;
    formulario.reset();
    setLockLocality(true);
    reset();
  };

  useEffect(() => {
    if (dirSave) {
      MisDatosService.updateDireccion(tempDirectionData)
        .then((response) => {
          if (response.data.error) {
            addErrorBack(response.data);
          } else {
            cargarDirecciones();
            StorageHelper.removeModalToUpMisDatos();
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            document
              .getElementById(`direction-back-${directionData.idDireccion}`)
              .click();
          }
        })
        .catch((er) => {
          console.log(er);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        });
    }
    setDirSave(false);
  }, [dirSave]);

  useEffect(() => {
    if (showAutoC || showAutoC2) {
      document.addEventListener('mouseup', handleOutsideGeolocalizator);
      document.addEventListener('keyup', handleOutsideGeolocalizator);
    }
  }, [showAutoC, showAutoC2]);

  useEffect(() => {
    if (isPostalCode) {
      if (
        postalCode !== null &&
        postalCode.length >= 3 &&
        findIn === 'cp' &&
        !clickSetValue
      ) {
        if (
          (HostProvider.isEroski() &&
            directionsHelper.regexpInicioCpTlfGibraltar.test(postalCode)) ||
          (HostProvider.isCaprabo() &&
            directionsHelper.expRegCodPostalAndorra.test(postalCode))
        ) {
          callGeolocalizacion();
        }
      } else setShowAutoC(false);
    } else setShowAutoC2(false);
  }, [postalCode, clickSetValue]);

  useEffect(() => {
    let nombreComponenteError = 'cod-entrega-';
    let nombreLabelError = 'codPostal-error-not-selected-';
    if (tempDirectionData.idDireccion !== null) {
      nombreComponenteError = `cod-entrega-${tempDirectionData.idDireccion}`;
      nombreLabelError = `codPostal-error-not-selected-${tempDirectionData.idDireccion}`;
    }
    const labelErrorGeneral = document.getElementById(
      `codPostal-error`,
    ) as HTMLLabelElement;
    const labelError = document.getElementById(
      nombreLabelError,
    ) as HTMLLabelElement;
    const componenteError = document.getElementById(
      nombreComponenteError,
    ) as HTMLInputElement;
    if (error) {
      if (labelErrorGeneral !== null) {
        labelErrorGeneral.classList.add('hide');
      }
      if (labelError !== null) {
        labelError.classList.remove('hide');
      }
      if (componenteError !== null) {
        componenteError.classList.add('error');
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (labelError !== null) {
        labelError.classList.add('hide');
      }
      if (componenteError !== null) {
        componenteError.classList.remove('error');
      }
    }
  }, [error]);

  useEffect(() => {
    if (
      tempDirectionData.roadName?.length >= 3 &&
      findIn === 'via' &&
      !clickSetValue
    ) {
      const country = directionsHelper.setCountryByPostalCode(
        tempDirectionData.postalCode,
      );
      directionsHelper.getGeoLocation(
        false,
        country,
        postalGeoData,
        isPostalCode,
        postalCode,
        tempDirectionData,
        setShowAutoC,
        setShowAutoC2,
        setLocation,
        setLocationRoad,
        setFirstRoadValue,
      );
    } else setShowAutoC2(false);
  }, [tempDirectionData.roadName, clickSetValue]);

  useEffect(() => {
    if (selectLocation?.codigo !== '') {
      setShowAutoC(false);
      setShowAutoC2(false);
      directionsHelper.retrieveLocationDetails(
        isPostalCode,
        postalCode,
        tempDirectionData,
        selectLocation,
        findIn,
        setShowAutoC,
        setShowAutoC2,
        setClickSetValue,
        setFindIn,
        setPostalCode,
        setTempDirectionData,
        trigger,
        setClickRoadValue,
        setLockLocality,
        setUnlockLocality,
      );
      directionsHelper.checkSiPrefijoDesaparecido(
        `pais-contacto-online-${directionData.idDireccion}`,
        postalCode,
        tempDirectionData,
        prefijosPaises,
        setPrefijo,
        setTamTelf,
        setTempDirectionData,
      );
      setErrorCpNoSeleccionado(false);
      clearErrors('localidadEntrega');
    }
  }, [selectLocation]);

  const revisarLocalidad = () => {
    if (
      (tempDirectionData.locality === '' ||
        tempDirectionData.locality === null) &&
      tempDirectionData.postalCode !== '' &&
      tempDirectionData.postalCode !== null &&
      tempDirectionData.roadName !== '' &&
      tempDirectionData.roadName !== null
    ) {
      setUnlockLocality(true);
    } else {
      setClearLocalityError(true);
    }
  };

  const onSubmit = () => {
    if (
      tempDirectionData.postalCode !== null &&
      tempDirectionData.postalCode?.length !== 0
    ) {
      if (isAdd) {
        addDireccion();

        const fromApp = StorageHelper.getFromApp() as string;
        const fromUrl = StorageHelper.getFromUrl() as string;
        if (fromApp === 'web_ecommerce' || fromApp === 'app_mcommerce') {
          if (!(fromUrl === null || fromUrl === undefined || fromUrl === '')) {
            window.location.href = fromUrl;
          }
        }
      } else {
        updateDireccion();
      }
    } else {
      setErrorCpNoSeleccionado(true);
    }
  };

  useEffect(() => {
    if (tempDirectionData.postalCode) {
      setValue('codPostal', tempDirectionData.postalCode);
      trigger('codPostal');
    }
  }, [tempDirectionData]);

  useEffect(() => {
    if (onLoad) {
      setTempDirectionData(directionData);
      const formulario = document.getElementById(
        `form-direccion-${tipo}-${directionData.idDireccion}`,
      ) as HTMLFormElement;
      formulario.reset();
      setOnLoad(false);
      setIsFullPrefijo(false);
    }
  }, [onLoad]);

  let titulo = '';
  let mensajeErrorCpValido = isCaprabo
    ? `${t('validaciones.not-valid-postalCode-caprabo')}`
    : `${t('validaciones.not-valid-postalCode')}`;
  if (tipo === 'entrega' && !isAdd) {
    titulo = `${t('datos.directions.dirDelivery')}`;
  } else if (isAdd) {
    titulo = `${t('datos.directions.newDirDelivery')}`;
    const elements = document.getElementsByClassName('bloqued');
    // eslint-disable-next-line no-plusplus
    for (let x = 0; x < elements.length; x++) {
      elements[x].setAttribute('disabled', 'disabled');
    }
  } else if (tipo === 'habitual') {
    titulo = `${t('datos.directions.dirHabitual')}`;
    mensajeErrorCpValido =
      isCaprabo && directionsHelper.checkIfCPIsAndorra(directionData.postalCode)
        ? `${t('validaciones.not-valid-postalCode-andorra')}`
        : `${t('validaciones.not-valid-postalCode-spain')}`;
    if (
      directionsHelper.checkIfCPIsGibraltar(directionData.postalCode) &&
      dataUser.user.isGibraltar
    ) {
      /* eslint-disable-next-line no-unused-expressions */
      document
        .getElementById(`cod-entrega-${directionData.idDireccion}`)
        ?.setAttribute('disabled', 'disabled');
      const elements = document.getElementsByClassName('no-gib');
      // eslint-disable-next-line no-plusplus
      for (let x = 0; x < elements.length; x++) {
        elements[x].classList.add('hidden');
      }
      const viaGibraltar = document.getElementsByClassName('big-gib');
      // eslint-disable-next-line no-plusplus
      for (let x = 0; x < viaGibraltar.length; x++) {
        viaGibraltar[x].classList.replace('col-md-4', 'col-md-12');
      }
    }
  }

  useEffect(() => {
    if (tipo === 'habitual' || tipo === 'entrega' || isAdd) {
      // @ts-ignore
      const isVisible = document
        .getElementById(
          !isAdd ? `${tipo}-${directionData.idDireccion}` : 'new-entrega',
        )
        .classList.contains('visible');
      if (isVisible) setVisible(true);
    }
  }, [onLoad]);

  useEffect(() => {
    if (unlockLocality) {
      setUnlockLocality(false);
      const inputLocality = document.getElementById(
        `localidad-entrega-${tempDirectionData.idDireccion}`,
      ) as HTMLInputElement;
      if (inputLocality) {
        inputLocality.removeAttribute('readonly');
        inputLocality.removeAttribute('style');
      }
    }
    if (lockLocality) {
      setLockLocality(false);
      const inputLocality = document.getElementById(
        `localidad-entrega-${tempDirectionData.idDireccion}`,
      ) as HTMLInputElement;
      if (inputLocality) {
        inputLocality.setAttribute('readOnly', 'true');
        Object.assign(inputLocality.style, {
          backgroundColor: '#dadada',
          opacity: '1',
          color: '#6e6e6e',
          cursor: 'default',
        });
      }
      clearErrors('localidadEntrega');
    }
  }, [unlockLocality, lockLocality]);

  useEffect(() => {
    if (clearLocalityError) {
      setClearLocalityError(false);
      clearErrors('localidadEntrega');
    }
  }, [clearLocalityError]);

  const handleClickCodigoPostal = (currentText) => {
    if (
      (directionsHelper.regexpInicioCpTlfGibraltar.test(postalCode) ||
        directionsHelper.expRegCodPostalAndorra.test(postalCode)) &&
      currentText.length >= 3
    ) {
      setShowAutoC(true);
      callGeolocalizacion();
    }
  };

  const autoCompletadoVia = () => {
    setIsPostalCode(false);
    setClickSetValue(false);
    setFindIn('via');
    if (tempDirectionData.roadName?.length >= 3 && !clickSetValue) {
      const country = directionsHelper.setCountryByPostalCode(
        tempDirectionData.postalCode,
      );
      directionsHelper.getGeoLocation(
        false,
        country,
        postalGeoData,
        false,
        postalCode,
        tempDirectionData,
        setShowAutoC,
        setShowAutoC2,
        setLocation,
        setLocationRoad,
        setFirstRoadValue,
      );
    } else {
      setShowAutoC2(false);
    }
  };

  return (
    <>
      <section
        id={!isAdd ? `${tipo}-${directionData.idDireccion}` : 'new-entrega'}
        className={`o-section--large ${
          !isAdd ? `form-${tipo}` : 'form-anadir'
        } bloque-form `}
      >
        <div className="container">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <a
            id={`direction-back-${directionData.idDireccion}`}
            href={isAdd ? '#entrega' : `#${tipo}`}
            onClick={() => {
              hideForm();
            }}
            className="link-prev"
          >
            <div className="icon icon-medium">
              <IconBack />
            </div>
            <p className="u-font-normal u-text-brand u-margin-left">
              {t('datos.directions.back')}
            </p>
          </a>
          <form
            id={`form-direccion-${tipo}-${directionData.idDireccion}`}
            className="form-datos"
            method="post"
            noValidate
          >
            <fieldset>
              <h2 className="bloque-datos__title u-text-brand">
                <span className="divider__square brand-color" />
                <span className="u-margin-right">{titulo}</span>
              </h2>
              <div className="row u-margin-bottom">
                <div className="col-12 col-md-4">
                  <div className="form-group u-margin-bottom">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="codPostal" className="control-label">
                      {t('datos.directions.postalCode')}
                    </label>
                    <div className="form-control-block">
                      <input
                        type="text"
                        className={`form-control ${
                          errors.codPostal ? 'error ' : ''
                        }`}
                        id="codPostal"
                        maxLength={MisDatosConstants.MAX_LENGTH_CODIGO_POSTAL}
                        value={tempDirectionData.postalCode}
                        {...register('codPostal', {
                          required: true,
                          validate: (e) => TextHelper.testPostalCode(e),
                          onChange: (e) => {
                            setClickSetValue(false);
                            HandleChange('postalCode', e.currentTarget.value);
                            setTempDirectionData({
                              ...tempDirectionData,
                              postalCode: e.currentTarget.value,
                            });
                            directionsHelper.corregirCPIfGibraltar(
                              e,
                              `codPostal`,
                              setPostalCode,
                              trigger,
                            );
                          },
                        })}
                        onKeyUp={(e) => {
                          setPostalCode(e.currentTarget.value);
                        }}
                        onClick={(e) => {
                          handleClickCodigoPostal(e.currentTarget.value);
                        }}
                        onFocus={(e) => {
                          setIsPostalCode(true);
                          setFindIn('cp');
                          if (
                            (directionsHelper.regexpInicioCpTlfGibraltar.test(
                              postalCode,
                            ) ||
                              directionsHelper.expRegCodPostalAndorra.test(
                                postalCode,
                              )) &&
                            e.currentTarget.value.length >= 3
                          ) {
                            callGeolocalizacion();
                          }
                        }}
                        autoComplete="nope"
                      />
                      {errors.codPostal &&
                        errors.codPostal.type === 'required' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="codPostal-error"
                            className="error"
                            htmlFor="codPostal"
                          >
                            {t('validaciones.empty-value')}
                          </label>
                        )}
                      {errors.codPostal &&
                        errors.codPostal.type === 'validate' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="codPostal-error"
                            className="error"
                            htmlFor="codPostal"
                          >
                            {mensajeErrorCpValido}
                          </label>
                        )}
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label
                        id={`codPostal-error-not-selected-${tempDirectionData.idDireccion}`}
                        className="error hide"
                        htmlFor="codPostal"
                      >
                        {t('validaciones.not-selected-postalCode')}
                      </label>
                      <ul
                        className={`ui-autocomplete ui-front ui-menu ui-widget ui-widget-content ui-corner-all ${
                          showAutoC ? 'visible' : 'display-none'
                        }`}
                        id={`ui-id-30-${tempDirectionData.idDireccion}`}
                      >
                        {location &&
                          location.map((loc) => (
                            <li
                              key={`ui-li-id-47-${loc.value}`}
                              className="ui-menu-item"
                              role="presentation"
                            >
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                              <a
                                id={`ui-id-47-${loc.id}`}
                                className="ui-corner-all"
                                onClick={() => {
                                  setSelectLocation(loc);
                                }}
                              >
                                {loc.value}
                              </a>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-4">
                  <div className="form-group select-wrapper u-margin-bottom">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label
                      className="control-label"
                      htmlFor="localidad-entrega"
                    >
                      {t('datos.directions.locality')}
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        errors.localidadEntrega ? 'error' : ''
                      }`}
                      readOnly
                      style={{
                        backgroundColor: '#dadada',
                        opacity: 1,
                        color: '#6e6e6e',
                        cursor: 'default',
                      }}
                      id="localidad-entrega"
                      value={tempDirectionData.locality}
                      onKeyPress={(e) =>
                        ignorarCaracteresLocalidadNoAceptados(e)
                      }
                      {...register('localidadEntrega', {
                        maxLength: MisDatosConstants.MAX_LENGTH_LOCALIDAD,
                        validate: () =>
                          TextHelper.testLocalidadEntrega(
                            tempDirectionData.locality,
                          ),
                      })}
                      onChange={(e) =>
                        HandleChange('locality', e.currentTarget.value)
                      }
                      maxLength={MisDatosConstants.MAX_LENGTH_LOCALIDAD}
                    />
                  </div>
                  {errors.localidadEntrega &&
                    errors.localidadEntrega.type === 'required' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="localidadEntrega-error"
                        className="error"
                        htmlFor="localidadEntrega"
                      >
                        {t('validaciones.empty-value')}
                      </label>
                    )}
                  {errors.localidadEntrega &&
                    errors.localidadEntrega.type === 'validate' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="localidadEntrega-error"
                        className="error"
                        htmlFor="localidadEntrega"
                      >
                        {t('validaciones.not-valid-characters-in-field')}
                      </label>
                    )}
                  {errors.localidadEntrega &&
                    errors.localidadEntrega.type === 'maxLength' && (
                      // eslint-disable-next-line jsx-a11y/label-has-associated-control
                      <label
                        id="localidadEntrega-error"
                        className="error"
                        htmlFor="localidadEntrega"
                      >
                        {t('validaciones.not-valid-characters-in-field')}
                      </label>
                    )}
                </div>
                <div
                  className={`col-12 col-md-4 ${
                    tipo === 'habitual' &&
                    directionsHelper.checkIfCPIsGibraltar(
                      tempDirectionData.postalCode,
                    )
                      ? 'big-gib'
                      : ''
                  }`}
                >
                  <div className="form-group u-margin-bottom">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="viaEntrega" className="control-label">
                      {t('datos.directions.roadName')}
                    </label>
                    <div className="form-control-block">
                      <input
                        type="text"
                        className={`form-control ${
                          errors.viaEntrega ? 'error' : ''
                        }`}
                        id="viaEntrega"
                        maxLength={
                          tipo === 'habitual' && dataUser.user.isGibraltar
                            ? MisDatosConstants.MAX_LENGTH_NOMBRE_DE_VIA_GIBRALTAR
                            : MisDatosConstants.MAX_LENGTH_NOMBRE_DE_VIA
                        }
                        defaultValue={tempDirectionData.roadName}
                        {...register('viaEntrega', {
                          required: true,
                          validate: (value) => TextHelper.testNombreVia(value),
                          onChange: (e) => {
                            HandleChange('roadName', e.currentTarget.value);
                          },
                        })}
                        onKeyUp={(e) => {
                          handleOutsideGeolocalizator(e);
                          setClickSetValue(false);
                          setClickRoadValue(false);
                        }}
                        onClick={() => {
                          autoCompletadoVia();
                        }}
                        onFocus={() => {
                          autoCompletadoVia();
                        }}
                        autoComplete="nope"
                      />
                      {errors.viaEntrega &&
                        errors.viaEntrega.type === 'required' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="viaEntrega-error"
                            className="error"
                            htmlFor="viaEntrega"
                          >
                            {t('validaciones.empty-value')}
                          </label>
                        )}
                      {errors.viaEntrega &&
                        errors.viaEntrega.type === 'validate' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="viaEntrega-error"
                            className="error"
                            htmlFor="viaEntrega"
                          >
                            {t('validaciones.not-valid-characters-in-field')}
                          </label>
                        )}
                      <ul
                        className={`ui-autocomplete ui-front ui-menu ui-widget ui-widget-content ui-corner-all ${
                          showAutoC2 ? 'visible' : 'display-none'
                        }`}
                        id={`ui-id-29-${tempDirectionData.idDireccion}`}
                      >
                        {locationRoad &&
                          locationRoad.map((loc) => (
                            <li
                              key={loc.value}
                              className="ui-menu-item"
                              role="presentation"
                            >
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                              <a
                                id="ui-id-47"
                                className="ui-corner-all"
                                onClick={() => {
                                  setSelectLocation(loc);
                                }}
                              >
                                {loc.value}
                              </a>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div
                  className={`col-4 col-md-1 ${
                    tipo === 'habitual' &&
                    directionsHelper.checkIfCPIsGibraltar(
                      tempDirectionData.postalCode,
                    )
                      ? 'no-gib'
                      : ''
                  }`}
                >
                  <div className="form-group u-margin-bottom">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="numEntrega" className="control-label">
                      {t('datos.directions.number')}
                    </label>
                    <div className="form-control-block">
                      <input
                        type="text"
                        className={`form-control ${
                          errors.numEntrega ? 'error' : ''
                        }`}
                        maxLength={MisDatosConstants.MAX_LENGTH_NUMERO}
                        id="numEntrega"
                        defaultValue={tempDirectionData.number}
                        {...register('numEntrega', {
                          ...testNumeroByCP(tempDirectionData.postalCode),
                          onChange: (e) => {
                            HandleChange('number', e.currentTarget.value);
                          },
                        })}
                      />
                      {errors.numEntrega &&
                        errors.numEntrega.type === 'required' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="numEntrega-error"
                            className="error"
                            htmlFor="numEntrega"
                          >
                            {t('validaciones.empty-value')}
                          </label>
                        )}
                      {errors.numEntrega &&
                        errors.numEntrega.type === 'pattern' && (
                          // eslint-disable-next-line jsx-a11y/label-has-associated-control
                          <label
                            id="numEntrega-error"
                            className="error"
                            htmlFor="numEntrega"
                          >
                            {t('validaciones.not-valid-value')}
                          </label>
                        )}
                    </div>
                  </div>
                </div>
                {HostProvider.isEroski() && (
                  <div
                    className={`col-4 col-md-1 ${
                      tipo === 'habitual' &&
                      directionsHelper.checkIfCPIsGibraltar(
                        tempDirectionData.postalCode,
                      )
                        ? 'no-gib'
                        : ''
                    }`}
                  >
                    <div className="form-group u-margin-bottom">
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label htmlFor="portal-entrega" className="control-label">
                        {t('datos.directions.portal')}
                      </label>

                      <div className="form-control-block">
                        <input
                          type="text"
                          className="form-control"
                          maxLength={MisDatosConstants.MAX_LENGTH_PORTAL}
                          id="portal-entrega"
                          value={
                            tempDirectionData && tempDirectionData.portal
                              ? tempDirectionData.portal
                              : ''
                          }
                          onChange={(e) =>
                            HandleChange('portal', e.currentTarget.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className={`col-4 col-md-1 ${
                    tipo === 'habitual' &&
                    directionsHelper.checkIfCPIsGibraltar(
                      tempDirectionData.postalCode,
                    )
                      ? 'no-gib'
                      : ''
                  }`}
                >
                  <div className="form-group u-margin-bottom">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="escalera-entrega" className="control-label">
                      {t('datos.directions.stairs')}
                    </label>
                    <div className="form-control-block">
                      <input
                        type="text"
                        className="form-control"
                        maxLength={MisDatosConstants.MAX_LENGTH_ESCALERA}
                        id="escalera-entrega"
                        defaultValue={
                          tempDirectionData && tempDirectionData.stairs
                            ? tempDirectionData.stairs
                            : ''
                        }
                        onChange={(e) =>
                          HandleChange('stairs', e.currentTarget.value)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`col-4 col-md-1 ${
                    tipo === 'habitual' &&
                    directionsHelper.checkIfCPIsGibraltar(
                      tempDirectionData.postalCode,
                    )
                      ? 'no-gib'
                      : ''
                  }`}
                >
                  <div className="form-group u-margin-bottom">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="piso-entrega" className="control-label">
                      {t('datos.directions.floor')}
                    </label>
                    <div className="form-control-block">
                      <input
                        type="text"
                        className="form-control"
                        maxLength={MisDatosConstants.MAX_LENGTH_PISO}
                        id="piso-entrega"
                        value={tempDirectionData.floor || ''}
                        onChange={(e) =>
                          HandleChange('floor', e.currentTarget.value)
                        }
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`col-4 col-md-1 ${
                    tipo === 'habitual' &&
                    directionsHelper.checkIfCPIsGibraltar(
                      tempDirectionData.postalCode,
                    )
                      ? 'no-gib'
                      : ''
                  }`}
                >
                  <div className="form-group u-margin-bottom">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="puerta-entrega" className="control-label">
                      {t('datos.directions.door')}
                    </label>
                    <div className="form-control-block">
                      <input
                        type="text"
                        className="form-control"
                        maxLength={MisDatosConstants.MAX_LENGTH_PUERTA}
                        id="puerta-entrega"
                        value={tempDirectionData.door || ''}
                        onChange={(e) =>
                          HandleChange('door', e.currentTarget.value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-4">
                  <div className="form-group select-wrapper u-margin-bottom">
                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                    <label htmlFor="tfOnline" className="control-label">
                      {t('datos.directions.contactPhone')}
                    </label>
                    <div className="u-display-flex">
                      <div className="form-control-block form-control--compound">
                        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label
                          className="hidden"
                          htmlFor="prefijoTelefonoMovil"
                        >
                          Selecciona el prefijo
                        </label>
                        <select
                          className={`form-control ${
                            errors.prefijoTelefonoMovil ? 'error' : ''
                          }`}
                          id="prefijoTelefonoMovil"
                          {...register('prefijoTelefonoMovil', {
                            required: true,
                            onChange: (e) => {
                              setIsValidPref1(!!e.target.value);
                              directionsHelper.retrievePrefijoByCountry(
                                e.currentTarget.value,
                                tempDirectionData,
                                prefijosPaises,
                                setPrefijo,
                                setTamTelf,
                                setTempDirectionData,
                              );
                              trigger('tfOnline');
                            },
                          })}
                        >
                          {prefijosPaises &&
                          isFullPrefijo &&
                          Object.keys(prefijosPaises).length > 0 ? (
                            prefijosPaises.map((p) =>
                              directionsHelper.logicaPrefijos(
                                p,
                                tempDirectionData,
                              ) ? (
                                <option
                                  selected={
                                    directionData.telefono1 === ''
                                      ? p.id ===
                                        MisDatosConstants.FLAG_NUMBER_ACTIVO
                                      : p.id ===
                                        Number(directionData.idPrefTelefono1)
                                  }
                                  key={p.id}
                                  value={p.id || ''}
                                >
                                  {p.prefijo}
                                </option>
                              ) : (
                                ''
                              ),
                            )
                          ) : (
                            <>
                              {!isValidPref1 && (
                                <option value="" selected>
                                  {' '}
                                </option>
                              )}
                              <option value={Number('1')} key={Number('1')}>
                                34
                              </option>
                            </>
                          )}
                        </select>
                        <div className="icon icon-small">
                          <IconChat />
                        </div>
                        {errors.prefijoTelefonoMovil &&
                          errors.prefijoTelefonoMovil.type === 'required' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="prefijoTelefonoMovil-error"
                              className="error"
                              htmlFor="prefijoTelefonoMovil"
                            >
                              {t('validaciones.empty-value')}
                            </label>
                          )}
                      </div>
                      <div className="form-control input-select">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.tfOnline ? 'error' : ''
                          }`}
                          id="tfOnline"
                          maxLength={tamTelf}
                          defaultValue={tempDirectionData.telefono1}
                          {...register('tfOnline', {
                            required: true,
                            validate: (value) =>
                              misDatosHelper.testTelefono(
                                `pais-contacto-online-${tempDirectionData.idDireccion}`,
                                value,
                              ),
                            onChange: (e) => {
                              onHandleTelephoneChange(e);
                            },
                          })}
                        />
                        {errors.tfOnline &&
                          errors.tfOnline.type === 'required' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="tfOnline-error"
                              className="error"
                              htmlFor="tfOnline"
                            >
                              {t('validaciones.empty-value')}
                            </label>
                          )}
                        {errors.tfOnline &&
                          errors.tfOnline.type === 'validate' && (
                            // eslint-disable-next-line jsx-a11y/label-has-associated-control
                            <label
                              id="tfOnline-error"
                              className="error"
                              htmlFor="tfOnline"
                            >
                              {prefijo === MisDatosConstants.PREFIJO_ESPANIA ||
                              prefijo === ''
                                ? t('validaciones.not-valid-phone-spain')
                                : prefijo ===
                                  MisDatosConstants.PREFIJO_GIBRALTAR
                                ? t('validaciones.not-valid-phone-gibraltar')
                                : prefijo ===
                                  MisDatosConstants.PREFIJO_INGLATERRA
                                ? t('validaciones.not-valid-phone-england')
                                : prefijo === MisDatosConstants.PREFIJO_ANDORRA
                                ? t('validaciones.not-valid-phone-andorra')
                                : ''}
                            </label>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="u-text-right">
                <button
                  type="button"
                  onClick={() => {
                    handleSubmit(onSubmit)();
                    revisarLocalidad();
                  }}
                  id={`direccion-submit-btn-${directionData.idDireccion}`}
                  className="btn btn-primary"
                >
                  {isAdd
                    ? t('datos.directions.add')
                    : t('datos.directions.update')}
                </button>
              </div>
            </fieldset>
          </form>

          {tipo !== 'habitual' && isCaprabo && (
            <p className="u-margin-top-large">
              {t('datos.directions.contact')}{' '}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="mailto:compraonlineSAC@caprabo.es" className="link">
                compraonlineSAC@caprabo.es
              </a>{' '}
              {t('datos.directions.or')}{' '}
              <a href="tel:932616060" className="link">
                932 61 60 60
              </a>{' '}
            </p>
          )}

          {tipo !== 'habitual' && isEroski ? (
            <p className="u-margin-top-large">
              {t('datos.directions.contact')}{' '}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="mailto:compraonline@eroski.es" className="link">
                compraonline@eroski.es
              </a>{' '}
              {t('datos.directions.or')}{' '}
              <a href="tel:944050514" className="link">
                944 050 514
              </a>{' '}
            </p>
          ) : (
            ''
          )}
        </div>
      </section>
    </>
  );
};

export default DirectionForm;
